import { combineReducers } from 'redux';

import analytics from './analytics';
import areYouStillWatching from './areYouStillWatching';
import auth from './auth';
import backRestoration from './backRestoration';
import clickedVideo from './clickedVideo';
import closedCaptioning from './closedCaptioning';
import closedCaptionSettings from './closedCaptionSettings';
import currentVideo from './currentVideo';
import dialog from './dialog';
import diff from './diff';
import exitDialog from './exitDialog';
import fms from './fms';
import geoInfo from './geoInfo';
import hero from './hero';
import idleMode from './idleMode';
import kitchenSink from './kitchenSink';
import leagues from './leagues';
import legalNotices from './legalNotices';
import localization from './localization';
import localMarkets from './localMarkets';
import log from './log';
import network from './network';
import pageView from './pageView';
import rotatingSegmentTitles from './rotatingSegmentTitles';
import scoring from './scoring';
import shows from './shows';
import sports from './sports';
import startup from './startup';
import syncbak from './syncbak';
import updateRotatingSegmentTitles from './updateRotatingSegmentTitles';

export default combineReducers({
  analytics,
  areYouStillWatching,
  auth,
  backRestoration,
  clickedVideo,
  closedCaptioning,
  closedCaptionSettings,
  currentVideo,
  dialog,
  diff,
  exitDialog,
  fms,
  geoInfo,
  hero,
  idleMode,
  kitchenSink,
  leagues,
  legalNotices,
  localization,
  localMarkets,
  log,
  network,
  pageView,
  rotatingSegmentTitles,
  scoring,
  shows,
  sports,
  startup,
  syncbak,
  updateRotatingSegmentTitles,
});
